import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './app.jsx'
import './index.css'

// Remove loading screen when React app loads
document.body.classList.add('app-loaded')

console.hidden = (...message) => {
  if (window.location.href.includes("localhost:3000")) {
    console.log(...message);
  }
  return;
}

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)